// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__WTiWL"};